<div class="read-log-header">
    <h1>{{workflow.UniqueRegistrationNumber}} {{workflow.Title}}</h1>
    <p class="form-description">{{workflow.Description}}</p>
</div>
<div class="readlog-stats">
    <div class="count" ng-if="workflow.TypeName!=='Caseflow'">
        <div class="header">{{ "readLog.primaryReadCount"|translate }}</div>
        <div>{{stats.TotalConsernedRead}} / {{stats.TotalConserned}}</div>
    </div>
    <div class="count" ng-if="workflow.TypeName==='Caseflow'">
        <div class="header">{{ "readLog.noOfReadings"|translate }}</div>
        <div>{{stats.TotalCaseRead}}</div>
    </div>
    <div class="count" ng-if="workflow.TypeName==='Caseflow'">
        <div class="header">{{ "readLog.noOfUsersRead"|translate }}</div>
        <div>{{stats.TotalCaseReadByUser}}</div>
    </div>
    <div ng-if="stats.Mandatory" class="confirmed">
        <div class="header">{{ "readLog.primaryConfirmedCount"|translate }}</div>
        <div>{{stats.TotalConfirmed}} / {{stats.TotalConserned}}</div>
    </div>
</div>